import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import type { TestTemplateId } from "@brewbase/db/types";
import { trpc } from "@/hooks/trpc";
import { MethodPage } from "@/features/analytics/methods/method-page";
import { WORKBENCH_SEARCH } from "@/features/analytics/workbench/use-workbench-route";

export const Route = createFileRoute("/analytics/methods/$template_id")({
  params: z.object({
    template_id: z.coerce.number().transform((v) => v as TestTemplateId),
  }),
  validateSearch: WORKBENCH_SEARCH,
  component: RouteComponent,
});

/** A method's queue and results (methods without a fixed analysis page). */
function RouteComponent() {
  const { template_id } = Route.useParams();
  const { data: template } = trpc.tests.testTemplates.getById.useQuery(template_id);
  if (!template?.blueprint) return null;
  return <MethodPage method={template} />;
}
